// =============================================================================
// Store: sesión reactiva (hallazgo A2 resuelto)
// -----------------------------------------------------------------------------
// Snapshot reactivo de usuario/permisos leídos de `session` (S3). Los datos
// fuertes siguen viviendo en la sesión en memoria/cifrada; aqui solo se exponen
// para que los componentes reaccionen a cambios sin leer SecureStorage c/u.
// =============================================================================
import { reactive } from 'vue';
import { session } from '@/utils/session';

const state = reactive({
  user: session.getUser() || null,
  permissions: session.getPermissions() || [],
});

export function useSessionStore() {
  const refresh = () => {
    state.user = session.getUser() || null;
    state.permissions = session.getPermissions() || [];
  };

  const hasPermission = (code) => session.hasPermission(code);

  return { state, refresh, hasPermission };
}